import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { filterPractitionersWithMedicalLicenceNumber } from '~legacy.personnel';

import { prescriptionVisitsTranslationKeys } from '../../translations';
import { PrescriptionVisitForm } from '../form/PrescriptionVisitForm';
import { addFormInitializer } from '../form/PrescriptionVisitForm.utils';

import { AddPrescriptionVisitModalLoader } from './AddPrescriptionVisitModal.loader';
import { PrescriptionVisitSaveButton } from './PrescriptionVisitSaveButton';

type AddPrescriptionVisitModalProps = {
   readonly onClose: VoidFunction;
};

export const AddPrescriptionVisitModal = (props: AddPrescriptionVisitModalProps): ReactElement => {
   return (
      <Modal
         testId={'addPrescriptionVisitModal'}
         title={prescriptionVisitsTranslationKeys.addPrescriptionVisit}
         onCloseRequest={props.onClose}
         shouldCloseOnOverlayClick={false}
         shouldCloseOnEsc={false}
         width={ModalWidth.WIDE}
         visible
         animateVisibility
      >
         <AddPrescriptionVisitModalLoader>
            {({ practitioners, healthcareProviderLocations, receptionServices }) => {
               const practitionersWithMedicalLicenceNumber = filterPractitionersWithMedicalLicenceNumber(practitioners);

               return (
                  <PrescriptionVisitForm
                     initializer={addFormInitializer(
                        healthcareProviderLocations,
                        practitionersWithMedicalLicenceNumber
                     )}
                     practitioners={practitionersWithMedicalLicenceNumber}
                     healthcareProviderLocations={healthcareProviderLocations}
                     receptionServices={receptionServices}
                     shouldAutoResolveReceptionService
                  >
                     {({ handleSubmit, formState }) => (
                        <>
                           <PrescriptionVisitSaveButton handleSubmit={handleSubmit} onSuccess={props.onClose} />
                           <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                           <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        </>
                     )}
                  </PrescriptionVisitForm>
               );
            }}
         </AddPrescriptionVisitModalLoader>
      </Modal>
   );
};
